import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  FilterFieldOption,
  FilterFieldOptionsHookResult,
} from "~/features/filter";
import {
  DealersLocationItem,
  useGetDealersLocationItemQuery,
} from "~/schemas/generated/graphql";

export const useCityOptions = (): FilterFieldOptionsHookResult => {
  const { t } = useTranslation();
  const { data, loading } = useGetDealersLocationItemQuery({
    variables: {
      item: DealersLocationItem["City"],
    },
  });

  const isEn = useMemo(() => localStorage.getItem("language") === "en", []);

  const rawItems = useMemo(() => {
    return (
      data?.DealerGetter?.getDealersLocationItem?.[
        isEn ? "itemsEn" : "items"
      ] ?? []
    );
  }, [data, isEn]);

  const options = useMemo<FilterFieldOption[]>(() => {
    return rawItems
      .filter((item): item is string => item != null)
      .map((item) => ({
        label: item,
        value: item,
      }));
  }, [rawItems]);

  return { options, loading };
};
